import CatImage from './CatImage';
export default CatImage;
